import { Grid, Typography } from '@mui/material';

export function nomineeDeclaration(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography sx={{ textAlign: 'justify' }}>
        Pursuant to SEBI circular dated 21/06/2023 and subsequent circulars / guidelines, AIF units
        are issued in dematerialised form and credited to investors demat accounts. Accordingly,
        Nomination for AIF units shall be as registered in the investor’s demat account with the
        Depository Participant. No separate nomination is being captured through this AIF
        application / portal . The Depository system shall be treated as the sole source for
        nomination records. Investors are requested to ensure that their nomination details are
        updated in their Demat Account
      </Typography>
    </Grid>
  );
}
